/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UpdateSummariesRequest } from '../models/UpdateSummariesRequest';
import type { UpdateSummariesResponse } from '../models/UpdateSummariesResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AiWorkstreamUpdateSummariesService {

    /**
     * Get Update Summaries
     * @param requestBody
     * @returns UpdateSummariesResponse Successful Response
     * @throws ApiError
     */
    public static getUpdateSummariesApiV1WorkstreamUpdateSummariesPost(
        requestBody: UpdateSummariesRequest,
    ): CancelablePromise<UpdateSummariesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/update-summaries',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
